import React from "react"

const DotsIcon = ({ }) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path stroke="none" d="M9.5 13 C9.5 13.8 8.8 14.5 8 14.5 C7.2 14.5 6.5 13.8 6.5 13 C6.5 12.2 7.2 11.5 8 11.5 C8.8 11.5 9.5 12.2 9.5 13 M9.5 8 C9.5 8.8 8.8 9.5 8 9.5 C7.2 9.5 6.5 8.8 6.5 8 C6.5 7.2 7.2 6.5 8 6.5 C8.8 6.5 9.5 7.2 9.5 8 M9.5 3 C9.5 3.8 8.8 4.5 8 4.5 C7.2 4.5 6.5 3.8 6.5 3 C6.5 2.2 7.2 1.5 8 1.5 C8.8 1.5 9.5 2.2 9.5 3" />
</svg>
export default DotsIcon
